import React, { useState } from 'react';
import newsearchfilter from './SearchFilterNew.scss'; // Import the SCSS file
import { MainPanel } from './panel/MainPanel';
import SearchRow from './SearchRow';
import classNames from 'classnames';
import { useRef } from 'react';
import { useEffect } from 'react';
import { Portal } from 'react-portal';
import { ActiveSectionProvider } from './panel/ActiveSectionContext';
import { selectLoading, selectLocalFilter } from 'data/search';
import { useSelector } from 'react-redux';
import Filtericon from '../../../../assets/images/Filteric.svg';

const SearchFilterNew = ({ setInputFlag, isAiSearchMode, pageVisible }) => {
  const [isOpen, setIsOpen] = useState(false);
  const newUIFilterDropdownRef = useRef(null); // Create a ref for the dropdown container
  const loading = useSelector(selectLoading);
  // Aggregate applied-filter count for the closed button's badge — benefits
  // manually-applied filters too, not just AI Search (Story 5 §2).
  const localFilter = useSelector(selectLocalFilter);
  const appliedFilterCount = localFilter?.length || 0;

  useEffect(() => {
    const handleClickOutside = (event) => {
      // console.log("Clicked outside");
      if (
        // newUIFilterDropdownRef.current &&
        // !newUIFilterDropdownRef.current.contains(event.target) &&
        event.target.classList.contains(newsearchfilter.overlay) // Check if clicked outside the dropdown container
        // !event.target.id.includes("newuifilterRef") &&
        // !event.target.getAttribute("tabindex") && // datepicker data select
        // event.target.innerText !== "Today" && // datepicker today button
        // !event.target.classList.contains(newsearchfilter.clsAutoSearchOption) &&
        // !event.target.classList.contains(newsearchfilter.clsListClearIcon)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // Portal escapes this page's display:none visibility toggle, so close it explicitly on navigation.
  useEffect(() => {
    if (pageVisible === false && isOpen) {
      setIsOpen(false);
    }
  }, [pageVisible]);

  const toggleDropdown = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  return (
    <div
      ref={newUIFilterDropdownRef}
      className={classNames(newsearchfilter.dropdownContainer, newsearchfilter.posUnset)}
    >
      <div onClick={!loading ? toggleDropdown : null} className={newsearchfilter.dropdownToggleBtn}>
        {loading ? (
          `Loading...`
        ) : (
          <>
            <img src={Filtericon} width="20" height="18" style={{ flexShrink: '0' }}></img>
            <span>Filters</span>
            {appliedFilterCount > 0 && (
              <span className={newsearchfilter.filterCountBadge}>{appliedFilterCount}</span>
            )}
          </>
        )}
      </div>

      {isOpen && pageVisible !== false && (
        <Portal isOpened>
          <div className={newsearchfilter.overlay}></div>
          <div className={newsearchfilter.dropdown}>
            <div className={newsearchfilter.dropdownHeader}>
              <SearchRow
                onClosePanel={toggleDropdown}
                setInputFlag={setInputFlag}
                isAiSearchMode={isAiSearchMode}
              />

              {/* <AppliedFilterSection /> */}
            </div>

            <div className={newsearchfilter.dropdownBody}>
              <ActiveSectionProvider>
                <MainPanel />
              </ActiveSectionProvider>
            </div>
            <div className={newsearchfilter.dropdownFooter}></div>
          </div>
        </Portal>
      )}
    </div>
  );
};

export default SearchFilterNew;
